import React from 'react';
import { Link } from 'react-router-dom';
import './NavigationBar.css';

const IncidentNavigationBar = () => (
  <header>
    <div className="header-content display-row">
      <div className="logo">
        <Link to="/incident"><img src="/images/wolken-logo.c2dc42f0ea3a9a44.png" alt="Wolken Logo" /></Link>
      </div>
      <div className="header-content-nav display-row">
        <nav>
          <ul className="display-row">
            <li>
              <span>ITSM/HR</span>
              <ul className="nav-submenu">
                <li>
                  <Link to="/incident" rel="noopener noreferrer">
                    <h5>Incident</h5>
                    <p>Incident Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/service_request" rel="noopener noreferrer">
                    <h5>Service Request</h5>
                    <p>Service Request Management</p>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/generic_request" rel="noopener noreferrer">
                    <h5>Generic Request</h5>
                    <p>Generic Request Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/service_catalog" rel="noopener noreferrer">
                    <h5>Service Catalog</h5>
                    <p>Service Catalog Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/change_request" rel="noopener noreferrer">
                    <h5>Change Request</h5>
                    <p>Change Request Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/cmdb" rel="noopener noreferrer">
                    <h5>CMDB</h5>
                    <p>CMDB Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/walkup" rel="noopener noreferrer">
                    <h5>Walkup</h5>
                    <p>Walkup Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/itsm_masters" rel="noopener noreferrer">
                    <h5>Masters</h5>
                    <p>Masters Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/kb" rel="noopener noreferrer">
                    <h5>Knowledge Base</h5>
                    <p>Knowledge Base Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/outage" rel="noopener noreferrer">
                    <h5>Outage</h5>
                    <p>Outage Management</p>
                  </Link>
                </li> */}
              </ul>
            </li>
            <li>
              <span>Docs [ITSM/HR]</span>
              <ul className="nav-submenu">
                <li>
                  <Link to="/incident/docs" rel="noopener noreferrer">
                    <h5>Incident Docs</h5>
                    <p>Incident Documentation</p>
                  </Link>
                </li>
                <li>
                  <Link to="/service_request/docs" rel="noopener noreferrer">
                    <h5>Service Request Docs</h5>
                    <p>Service Request Documentation</p>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/generic_request/docs" rel="noopener noreferrer">
                    <h5>Generic Request Docs</h5>
                    <p>Generic Request Documentation</p>
                  </Link>
                </li>
                <li>
                  <Link to="/service_catalog/docs" rel="noopener noreferrer">
                    <h5>Service Catalog Docs</h5>
                    <p>Service Catalog Documentation</p>
                  </Link>
                </li>
                <li>
                  <Link to="/change_request/docs" rel="noopener noreferrer">
                    <h5>Change Request Docs</h5>
                    <p>Change Request Documentation</p>
                  </Link>
                </li>
                <li>
                  <Link to="/cmdb/docs" rel="noopener noreferrer">
                    <h5>CMDB Docs</h5>
                    <p>CMDB Documentation</p>
                  </Link>
                </li>
                <li>
                  <Link to="/walkup/docs" rel="noopener noreferrer">
                    <h5>Walkup Docs</h5>
                    <p>Walkup Documentation</p>
                  </Link>
                </li>
                <li>
                  <Link to="/itsm_masters/docs" rel="noopener noreferrer">
                    <h5>Masters Docs</h5>
                    <p>Masters Documentation</p>
                  </Link>
                </li>
                <li>
                  <Link to="/kb/docs" rel="noopener noreferrer">
                    <h5>Knowledge Base Docs</h5>
                    <p>Knowledge Base Documentation</p>
                  </Link>
                </li>
                <li>
                  <Link to="/outage/docs" rel="noopener noreferrer">
                    <h5>Outage Docs</h5>
                    <p>Outage Documentation</p>
                  </Link>
                </li> */}
              </ul>
            </li>
            <li>
              <Link to="/itsm_get_apis" id="fetch-new-get-apis" rel="noopener noreferrer">
                Get APIs <span className="new-flash">NEW</span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
);

export default IncidentNavigationBar;
